angular.module('todo')
    .component('todoStatusLabel', {
        bindings: {
            status: '<',
            flag: '<'
        },
        template: `
            <span ng-if="$ctrl.status && $ctrl.flag === true" class="todo-status-label {{$ctrl.status}}" title="{{ \'todo.status.\'.concat($ctrl.status) | translate }}"><i class="flag fa fa-fw fa-font-awesome"></i></span>
            <span ng-if="$ctrl.status && !$ctrl.flag" class="label label-default todo-status-label {{$ctrl.status}}">{{ \'todo.status.\'.concat($ctrl.status) | translate }}</span>
            <span ng-if="$ctrl.status == null">brak</span>
        `
    })
